<script>
import SimpleCheckbox from 'tripod-styles/src/components/Checkboxes/SimpleCheckbox.svelte';
import DesktopCard from './components_new/DesktopCard.svelte';
import CoreBaseCard from './components_new/CoreBaseCard.svelte';
    import { PlansStore } from '../Plans.store';
    import { PlansSizeStore } from '../PlansSizeStore';

export let changeInterval;
export let lang;
export let membership_selected
export let onSelectPlan;
export let affiliate;
export let user;
export let interval;
export let tripod_plans;

let parsedPlans = [];

let device = "is-desktop";
$: device = $PlansSizeStore >= 900 ? "is-desktop" : "is-mobile";
</script>

<div class="columns is-multiline">
    <div class="column">
        <div class="box-plans">
            {#if $PlansStore.plans_views.length > 0}
                <div class="flex-center has-text-centered">
                    <div class="buttons py-alt-4 is-grouped px-alt-2 is-grid is-gap-20 checkboxes-interval {device}" style="grid-template-columns: 1fr 1fr;">
                        <SimpleCheckbox has_circle="{false}" is_column={false}>
                            <input type="radio" class="formElements" checked={interval === "month"} name="interval" value="month" on:change={()=>{
                                changeInterval("month")
                            }} required>
                            <svelte-fragment slot="content">
                                <span class="is-hidden-mobile">
                                    Plan
                                </span>
                                <span>
                                    {lang.month}
                                </span>
                            </svelte-fragment>
                        </SimpleCheckbox>
                        <SimpleCheckbox has_circle="{false}" is_column={false}>
                            <input type="radio" class="formElements" checked={interval === "year"} name="interval" value="year" on:change={()=>{
                                changeInterval("year")
                            }} required>
                            <svelte-fragment slot="content">
                                <span class="is-hidden-mobile">
                                    Plan
                                </span>
                                <span>
                                    {lang.year}
                                </span>
                            </svelte-fragment>
                        </SimpleCheckbox>
                    </div>
                </div>
            {/if}
            <div class="is-grid plans-container {device} plans-count-{parsedPlans.length} is-flex-mobile is-centered is-justify-content-center">
                <CoreBaseCard 
                    membership_selected={membership_selected} 
                    onSelectPlan={onSelectPlan} 
                    affiliate={affiliate} 
                    user={user} 
                    interval={interval} 
                    tripod_plans={tripod_plans} 
                    bind:parsedPlans={parsedPlans}
                />
            </div>
            <!--
            <p class="has-text-centered has-text-dark" style="padding-top: 2rem;">
                {lang.help.needhelp}
            </p>
            <p class="has-text-centered">
                <a rel="noreferrer" href="https://3pod.io/contactanos" target="_blank" class="has-text-primary fw600">
                    {lang.help.contactus}
                </a>
            </p>
            -->
        </div>
    </div>
</div>
<style>
.checkboxes-interval :global(checkradio-container){
    width:100%;
    min-width:200px;
    max-width:220px;
}
.plans-container.is-mobile:global(.plans-count-1), .plans-container.is-mobile:global(.plans-count-2){
    justify-content: flex-start !important;
    display: flex;
    max-width: 600px;
}

.checkboxes-interval.is-mobile :global(checkradio-container){
    min-width:120px;
    max-width:440px;
}
</style>